if (!customElements.get('subscription-product-chooser')) {
  customElements.define('subscription-product-chooser', class SubscriptionProductChooser extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[data-subscription-mode]');
      this.descriptions = this.querySelectorAll('[data-subscription-description]');
      this.status = this.querySelector('[data-subscription-status]');
      this.productLinks = this.querySelectorAll('[data-subscription-product-card] a[href]');

      this.productLinks.forEach((link) => {
        link.dataset.subscriptionRegularUrl = link.href;
      });
      this.buttons.forEach((button) => button.addEventListener('click', () => this.setMode(button.dataset.subscriptionMode)));
    }

    connectedCallback() {
      this.setMode('regular', false);
    }

    setMode(mode, announce = true) {
      const isGift = mode === 'gift';
      this.buttons.forEach((button) => {
        const isActive = button.dataset.subscriptionMode === mode;
        button.setAttribute('aria-pressed', String(isActive));
        button.classList.toggle('button--primary', isActive);
        button.classList.toggle('button--secondary', !isActive);
      });
      this.descriptions.forEach((description) => {
        description.hidden = description.dataset.subscriptionDescription !== mode;
      });
      this.productLinks.forEach((link) => {
        const url = new URL(link.dataset.subscriptionRegularUrl, window.location.origin);
        if (isGift) url.searchParams.set('view', this.dataset.giftView);
        link.href = isGift ? `${url.pathname}${url.search}${url.hash}` : link.dataset.subscriptionRegularUrl;
      });
      if (announce) this.status.textContent = `${isGift ? 'Gift' : 'Regular'} subscriptions selected.`;
    }
  });
}
